import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import TimePicker from "@mui/lab/TimePicker";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { convertToHTML } from "draft-convert";
import { EditorState } from "draft-js";
import moment from "moment";
import React, { useState, useEffect, useRef } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Link, useParams } from "react-router-dom";
import "./AddProductS.css";
import { useHistory } from "react-router-dom";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { serverInfo } from "../../../../../../../../App";
import { useContext } from "react";
import useFileHandleS3 from "../../../../../../../../CustomHooks/useFileHandleS3";
import useProductImageHandleS3 from "../../../../../../../../CustomHooks/useProductImageHandleS3";
import MediaUploadProgressBar from "../../../../../../../../Screen/MediaUploadProgressBar";

const EditProductAuction = () => {
  const { imageCdnUrl } = useContext(serverInfo);

  let { id } = useParams();

  const [convertedContent, setConvertedContent] = useState(null);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [starId, setStarId] = useState("");
  const [starList, setStarList] = useState([]);
  const [errorList, setErrorList] = useState([]);

  const fileInputRef = useRef(null);
  const imageInputRef = useRef(null);


    // File Handle Banner
    const [filePath, setFilePath] = useState("");
    const [file, setFile] = useState("");
    const [delKey, setDelKey] = useState(null);
    const [fileUrl, fileKey, progress] = useFileHandleS3(file, 'auction/images', delKey);
  
  
    // File Handle Product Image
    const [imagePath, setImagePath] = useState("");
    const [productImage, setProductImage] = useState('');
    const [productImageDelKey, setProductImageDelKey] = useState(null);
    const [productImageUrl,productImageKey,progressBar] = useProductImageHandleS3(productImage, 'auction/images', productImageDelKey);
  
    const bannerHandler = (file) => {
      setDelKey(fileKey);
      setFile(file[0]);
    };
  
    const productImageHandler = (file) => {
      setProductImageDelKey(productImageKey);
      setProductImage(file[0]);
    };
  
  
    const deleteFile = ()=>
    {
      setFile(null);
      setDelKey(fileKey);
      fileInputRef.current.value = '';
  
    }

    const deleteProductImage = ()=>
    {
      setProductImage(null);
      setProductImageDelKey(productImageKey);
      imageInputRef.current.value = '';
  
    }

  useEffect(() => {
    axios.get(`/api/admin/edit/auction/${id}`).then((res) => {
      if (res.status === 200) {
        setInputFieldList(res.data.product);
        setFilePath(res.data.product.banner);
        setImagePath(res.data.product.product_image);
        setStarId(res.data.product.star_id);
      }
    });
    axios.get(`/api/admin/star_list`).then((res) => {
      if (res.status === 200) {
        setStarList(res.data.star);
      }
    });
  }, []);

  const [inputFieldList, setInputFieldList] = useState({
    title: "",
    keyword: "",
    details: "",
    base_price: "",
    bid_from: "",
    bid_to: "",
    banner: "",
    product_image: "",
    result_date: "",
    product_delivery_date: "",
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setInputFieldList((prev) => {
      return { ...prev, [name]: value };
    });
  };



  const dataSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const fData = new FormData();

    fData.append("title", inputFieldList.title);
    fData.append("star_id", starId);
    fData.append("keyword", inputFieldList.keyword);
    fData.append("details", convertedContent);
    fData.append("base_price", inputFieldList.base_price);
    fData.append("bid_from", inputFieldList.bid_from);
    fData.append("bid_to", inputFieldList.bid_to);
    fData.append("result_date", inputFieldList.result_date);
    fData.append("product_delivery_date", inputFieldList.product_delivery_date);
    fData.append("banner", fileKey?fileKey:filePath);
    fData.append("product_image", productImageKey?productImageKey:imagePath);
    fData.append("status", 0);


    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/admin/update/auction/${id}`, fData).then((res) => {
        setLoading(false);
        if (res.data.status === 402) {
          setErrorList(res.data.errors);
        } else {
          if(file){
            setFile('');
            setDelKey(filePath.split("com/").pop())
          }
          if(productImage){
            setProductImage('');
            setProductImageDelKey(imagePath.split("com/").pop())
          }
          history.push("/superstar-admin/auction/product-list/pending");
        }
      });
    });
  };

  return (
    <>
      <div className="text-light d-flex border border-warning rounded-3 justify-content-center p-2 m-1">
        <div className="faTrophy">
          <i className="fa-solid fa-calendar-plus"></i>
        </div>
        <h4 className="mx-3 text-warning p-2">Edit Product</h4>
      </div>

      <div className="card card-bg mb-2 p-2 mt-3 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form>
                  <div className="form-group row my-4">
                    <div className="col-md-3 label-text">
                      <p> Select Star</p>
                    </div>
                    <div className="col-md-9">
                      <select
                        onChange={handleInput}
                        name="star_id"
                        className="form-control reply-control"
                        value={inputFieldList.star_id}
                      >
                        <option className="text-black" value="">
                          Choose One
                        </option>
                        {starList.map((star, index) => (
                          <option className="text-black" value={star.id}>
                            {star?.first_name} {star?.last_name}
                          </option>
                        ))}
                      </select>
                      <span className="text-danger">{errorList.star_id}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Title</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="text"
                        onChange={handleInput}
                        name="title"
                        value={inputFieldList.title}
                      />
                      <span className="text-danger">{errorList.title}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Keyword</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="text"
                        onChange={handleInput}
                        name="keyword"
                        value={inputFieldList.keyword}
                      />
                      <span className="text-danger">{errorList.keyword}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Description</p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        editor={ClassicEditor}
                        data={inputFieldList.details}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setConvertedContent(data);
                        }}
                      />
                      <span className="text-danger">{errorList.details}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Base Price</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="number"
                        name="base_price"
                        onChange={handleInput}
                        value={inputFieldList.base_price}
                      />
                      <span className="text-danger">
                        {errorList.base_price}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4 label-text">
                    <div className="col-md-3 label-text">
                      <p>Bidding Deadline</p>
                    </div>
                    <div className="col-sm-4">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="bid_from"
                        value={moment(inputFieldList.bid_from).format(
                          "YYYY-MM-DD"
                        )}
                      />
                      <span className="text-danger">{errorList?.bid_from}</span>
                    </div>{" "}
                    To
                    <div className="col-sm-4">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="bid_to"
                        value={moment(inputFieldList.bid_to).format(
                          "YYYY-MM-DD"
                        )}
                      />
                      <span className="text-danger">{errorList?.bid_to}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Result Published</p>
                    </div>

                    <div className="col-sm-5">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="result_date"
                        value={moment(inputFieldList.result_date).format(
                          "YYYY-MM-DD"
                        )}
                      />
                      <span className="text-danger">
                        {errorList?.result_date}
                      </span>
                    </div>
                  </div>
                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Product Delivery</p>
                    </div>
                    <div className="col-sm-5">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="product_delivery_date"
                        value={moment(
                          inputFieldList.product_delivery_date
                        ).format("YYYY-MM-DD")}
                      />
                      <span className="text-danger">
                        {errorList?.product_delivery_date}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Banner</>
                      </p>
                    </div>
                    <div className="col-md-5">
                    {fileUrl && file? (
                        <div className="position-relative">
                    
                          <img
                          src={fileUrl}
                          className="img-fluid avatar-img-src"
                          alt=""
                          style={{ maxHeight: "300px" }}
                        />  
                       <span className="text-warning right-cross-button" onClick={deleteFile}>X</span>
                        </div>
                      ) : (
                        <img
                          src={imageCdnUrl + filePath}
                          className="img-fluid avatar-img-src"
                          alt=""
                          style={{ maxHeight: "300px" }}
                        />
                      )}

                      <input
                        type="file"
                        className="form-control reply-control"
                        onChange={(e) => bannerHandler(e.target.files)}
                        id="image"
                        name="image"
                        ref={fileInputRef}
                      />
                   {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                    </div>
                  </div>


                   <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Product Image</>
                      </p>
                    </div>
                    <div className="col-md-5">
                    {productImageUrl && productImage? (
                        <div className="position-relative">
                    
                          <img
                          src={productImageUrl}
                          className="img-fluid avatar-img-src"
                          alt=""
                          style={{ maxHeight: "300px" }}
                        />  
                       <span className="text-warning right-cross-button" onClick={deleteProductImage}>X</span>
                        </div>
                      ) : (
                        <img
                          src={imageCdnUrl + imagePath}
                          className="img-fluid avatar-img-src"
                          alt=""
                          style={{ maxHeight: "300px" }}
                        />
                      )}
                      <input
                        className="form-control reply-control"
                        type="file"
                        onChange={(e) => productImageHandler(e.target.files)}
                        ref={imageInputRef}
                      />
                     {productImage && !productImageUrl && <MediaUploadProgressBar progress={progressBar} />}
                      <span className="text-danger">{errorList.image}</span>
                    </div>
                  </div>
                  {/* Update Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-3 label-text"></div>
                    <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                      {loading ? (
                        <>
                          <button className="btn btnUpdate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button
                          className="btn btnUpdate fw-bold"
                          type="submit"
                          onClick={dataSubmit}
                        >
                          Update
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Update Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditProductAuction;
